module.exports = __webpack_public_path__ + "images/application/illustrations/safe-ee41bcf4.svg";